import { __read, __spread } from "tslib";
import { useEffect } from 'react';
import { rcConfiguration } from '../config';
function showDeprecated(_a) {
    var component = _a.component, target = _a.target, time = _a.time, comment = _a.comment, message = _a.message, level = _a.level;
    var _b;
    var showMessage = message ||
        "props => (" + target + ") be deprecated, that will be remove in " + time + " release" + (comment ? ", " + comment : '');
    (_b = rcConfiguration.WARNING_FUNCTION) === null || _b === void 0 ? void 0 : _b.call(rcConfiguration, "JUNO [" + component + "]: " + showMessage, {
        level: level,
    });
}
export function logInDev(args, cb) {
    if (process.env.NODE_ENV !== 'production' &&
        !rcConfiguration.WARNING_IGNORE) {
        showDeprecated(args);
        cb === null || cb === void 0 ? void 0 : cb();
    }
}
export var useDeprecatedLog = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (process.env.NODE_ENV !== 'production' &&
        !rcConfiguration.WARNING_IGNORE) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(function () {
            logInDev.apply(void 0, __spread(args));
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    }
};
export function useDeprecatedCheck(Component, props, depreciates, source) {
    var name = Component.displayName || source || '';
    if (process.env.NODE_ENV !== 'production' &&
        !rcConfiguration.WARNING_IGNORE) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(function () {
            depreciates.forEach(function (_a) {
                var prop = _a.prop, comment = _a.comment, time = _a.time;
                var _b;
                if (props[prop] !== undefined &&
                    // * also not to be default value
                    props[prop] !== ((_b = Component.defaultProps) === null || _b === void 0 ? void 0 : _b[prop])) {
                    showDeprecated({
                        component: name,
                        target: prop,
                        time: time,
                        comment: comment,
                    });
                }
            });
        });
    }
}
